angular
  .module('resources.Tag', ['ngResource'])
  .factory('Tag', ['$resource', function ($resource) {
    var resource = $resource('/api/tags/:id', {id: '@_id'}, {
      query: {
        method: 'GET',
        isArray: false,
        url: '/api/admin/tags',
      },
      update: {
        method: 'PUT'
      },
      delete: {
        isArray: false,
        method: 'DELETE'
      },
      search: {
        method: 'GET',
        url: '/api/tags-search',
        isArray: true
      },
      mergeTags: {
        method: 'POST',
        url: '/api/tags/panel/merge',
      }
    });

    return resource;
  }]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Tag.js